"use client";

import { useEffect } from "react";

function isRscNavCrash(message: string): boolean {
  return (
    message.includes("Minified React error #412") ||
    message.includes("Connection closed.") ||
    message.includes("Failed to fetch RSC")
  );
}

/**
 * El fallo RSC #412 ocurre fuera del error boundary y deja la pantalla
 * "This page couldn't load". Un reload completo sí funciona; lo hacemos
 * una vez por ruta para no entrar en bucle.
 */
export function RscNavRecovery() {
  useEffect(() => {
    const recover = (message: string) => {
      if (!isRscNavCrash(message)) return;
      const key = `rsc-recovery:${window.location.pathname}`;
      const last = Number(sessionStorage.getItem(key) || "0");
      if (Date.now() - last < 8000) return;
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    };

    const onError = (event: ErrorEvent) => recover(String(event.message || ""));
    const onRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const message =
        typeof reason === "string"
          ? reason
          : reason instanceof Error
            ? reason.message
            : String(reason ?? "");
      recover(message);
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
